import { useQuery } from "@tanstack/react-query";
import { getCompanySettings as getCompanySettingsService } from "services/CompanySettings.services";

export default function useFindings() {
  const companySettings = useQuery<any>({
    queryKey: ["companySettings"],
    queryFn: getCompanySettingsService,
  });

  return {
    companySettings,
  };
}
